<vdr-page-block>
  <vdr-action-bar>
    <vdr-ab-left>
      <vdr-language-selector
        [availableLanguageCodes]="availableLanguages$ | async"
        [currentLanguageCode]="contentLanguage$ | async"
        (languageCodeChange)="setLanguage($event)"
      ></vdr-language-selector>
    </vdr-ab-left>
    <vdr-ab-right>
      <vdr-action-bar-items locationId="product-list"></vdr-action-bar-items>
        <button
          type="button"
          class="button secondary mr-1"
          [disabled]="!selectionManager.selection.length"
          (click)="batchCreateInSuyoda()"
        >
          {{ "catalog.batch-create-in-suyoda" | translate }}
        </button>
      <a
        class="button primary mr-1"
        [routerLink]="['/catalog/products/create']"
        *vdrIfPermissions="['CreateCatalog', 'CreateProduct']"
      >
        <clr-icon shape="plus"></clr-icon>
        {{ "catalog.create-new-product" | translate }}
      </a>
      <vdr-action-bar-dropdown-menu
        [alwaysShow]="true"
        locationId="product-list"
      >
        <button
          type="button"
          vdrDropdownItem
          (click)="rebuildProductAdvancedIndex()"
        >
          <clr-icon shape="refresh" class=""></clr-icon>
          {{ "catalog.rebuild-search-index" | translate }}
        </button>
        <button
          type="button"
          vdrDropdownItem
          (click)="clearProductCache()"
        >
          <clr-icon shape="trash" class=""></clr-icon>
          {{ "catalog.clear-product-cache" | translate }}
        </button>
      </vdr-action-bar-dropdown-menu>
    </vdr-ab-right>
  </vdr-action-bar>
</vdr-page-block>
<vdr-data-table-2
  class="mt-2"
  id="product-list"
  [items]="items$ | async"
  [itemsPerPage]="itemsPerPage$ | async"
  [totalItems]="totalItems$ | async"
  [currentPage]="currentPage$ | async"
  [filters]="filters"
  (pageChange)="setPageNumber($event)"
  (itemsPerPageChange)="setItemsPerPage($event)"
>
  <vdr-bulk-action-menu
    locationId="product-list"
    [hostComponent]="this"
    [selectionManager]="selectionManager"
  ></vdr-bulk-action-menu>
  <vdr-dt2-search
    [searchTermControl]="searchTermControl"
    [searchTermPlaceholder]="
      'settings.search-by-product-name-or-sku' | translate
    "
  />
  <vdr-dt2-column
    [heading]="'common.id' | translate"
    id="id"
    [hiddenByDefault]="true"
    [sort]="sorts.get('id')"
  >
    <ng-template let-product="item">
      {{ product.id }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.created-at' | translate"
    id="created-at"
    [hiddenByDefault]="true"
    [sort]="sorts.get('createdAt')"
  >
    <ng-template let-product="item">
      {{ product.createdAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.updated-at' | translate"
    id="updated-at"
    [hiddenByDefault]="true"
    [sort]="sorts.get('updatedAt')"
  >
    <ng-template let-product="item">
      {{ product.updatedAt | localeDate : "short" }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'common.image' | translate"
    id="image"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <div class="image-placeholder">
        <img
          *ngIf="product.featuredAsset as asset; else imagePlaceholder"
          [src]="asset | assetPreview : 'tiny'"
        />
        <ng-template #imagePlaceholder>
          <div class="placeholder">
            <clr-icon shape="image" size="48"></clr-icon>
          </div>
        </ng-template>
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.name' | translate"
    id="prod-name"
    [optional]="false"
    [sort]="sorts.get('name')"
  >
    <ng-template let-product="item">
      <a
        class="button-ghost"
        [routerLink]="['/catalog/products', product.id]"
        style="
          max-width: 300px;
          overflow: hidden;

          text-overflow: ellipsis;
          justify-content: start;
        "
        ><span style="text-overflow: ellipsis; overflow: hidden">{{
          product.name
        }}</span
        ><clr-icon shape="arrow right"
      /></a>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.slug' | translate"
    id="slug"
    [hiddenByDefault]="true"
    [sort]="sorts.get('slug')"
  >
    <ng-template let-product="item">
      {{ product.slug }}
    </ng-template>
  </vdr-dt2-column>
  <vdr-dt2-column
    [heading]="'catalog.visibility' | translate"
    id="enabled"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <vdr-chip *ngIf="product.enabled" colorType="success">{{
        "common.enabled" | translate
      }}</vdr-chip>
      <vdr-chip *ngIf="!product.enabled" colorType="warning">{{
        "common.disabled" | translate
      }}</vdr-chip>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.startTime' | translate"
    id="startTime"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <div *ngIf="product.customFields.startTime">
        {{ product.customFields.startTime | localeDate : "medium" }}
      </div>
      <div *ngIf="!product.customFields.startTime">
        {{ "*" }}
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.endTime' | translate"
    id="endTime"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <div *ngIf="product.customFields.endTime">
        {{ product.customFields.endTime | localeDate : "medium" }}
      </div>
      <div *ngIf="!product.customFields.endTime">
        {{ "*" }}
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.preorderStock' | translate"
    id="preorderStock"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <div>
        {{ product.customFields.customThreshold ?? 0 }}
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.shippingSetting' | translate"
    id="shippingSetting"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <div>
        {{ product.customFields.shippingSetting }}
      </div>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.facets' | translate"
    id="facets"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <facets-column [rowItem]="product"></facets-column>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'common.artistName' | translate"
    id="artist"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <artist-column [rowItem]="product"></artist-column>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.totalSalesQuantity' | translate"
    id="sales"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <total-sale-column [rowItem]="product"
      *ngIf="canReadStatistics(product)"
      ></total-sale-column>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.stockQuantities' | translate"
    id="stock"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      <stock-quantites-column [rowItem]="product"></stock-quantites-column>

      <!-- {{ product.stock }} -->
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.unshipped-quantity' | translate"
    id="stock"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      {{ product.unshippedQuantity }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.price' | translate"
    id="price"
    [hiddenByDefault]="false"
  >
    <ng-template let-product="item">
      {{ productPrice(product) }}
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.status' | translate"
    id="status"
    [hiddenByDefault]="true"
  >
    <ng-template let-product="item">
      <vdr-chip
        *ngIf="product.customFields.status === 'Approved'"
        colorType="success"
      >
        {{ product.customFields.status }}
      </vdr-chip>
      <vdr-chip
        *ngIf="product.customFields.status === 'Waiting For Approve'"
        colorType="warning"
      >
        {{ product.customFields.status }}
      </vdr-chip>
      <vdr-chip
        *ngIf="product.customFields.status === 'Rejected'"
        colorType="error"
      >
        {{ product.customFields.status }}
      </vdr-chip>
    </ng-template>
  </vdr-dt2-column>

  <vdr-dt2-column
    [heading]="'catalog.number-of-variants' | translate"
    id="number-of-variants"
    [hiddenByDefault]="true"
  >
    <ng-template let-product="item">
      {{
        "catalog.variant-count"
          | translate : { count: product.variantList?.totalItems }
      }}
    </ng-template>
  </vdr-dt2-column>

  <!-- <ng-container *ngFor="let customField of customFieldsDefault()">
    <vdr-dt2-custom-field-column [customField]="customField" [sorts]="sorts"
  /></ng-container> -->
</vdr-data-table-2>
